import React, { Component } from 'react';
import VisibilitySensor from 'react-visibility-sensor';
import {jsonUrl,equalHeights} from '../components/Factory' 
import News from '../components/News'; 


class NewsContainer extends Component {
	constructor(props) {
		super(props);
		this.state = { 
		  newsData: this.props.resolves.newsData,
		  offset : 6,
		  finished:'block'
		}
		this.onChange = this.onChange.bind(this);
	}
	onChange(isVisible){
		if(isVisible) { 
			this.loadMore();
		}
	}	
	loadMore(){
		fetch(jsonUrl({ 	number:6,
							offset:this.state.offset,
							type:'aktuelles',
						}))
					  .then(res => res.json())
					  .then(res => {
							if(res.length>0)
								this.setState({
									newsData: [...this.state.newsData,...res],
									offset: this.state.offset+6
								});
							else
								this.setState({
									finished:'none'
								});
							equalHeights('article-item');	
					  })
	}
	componentWillMount(){
		document.body.scrollTop = document.documentElement.scrollTop = 0;
	}
	componentDidMount(){	
		setTimeout(function(){
			document.getElementById('menu-informationen').classList.add('active');
			equalHeights('article-item');
		},400);
	}
	componentWillUnmount(){
		document.getElementById('menu-informationen').classList.remove('active');
	}
	render() {		   
		   return (
				<div>
					<News newsData={this.state.newsData } staticData={this.props.resolves.staticData} />
					<VisibilitySensor onChange={this.onChange}>
						<div className="loading small" style={{display:this.state.finished}}>
							<div className="one"></div>			
						</div>
					</VisibilitySensor>
				</div>
			)
	   
	}
}
export function getNewsData(){
	return fetch(jsonUrl({ 
						number:6,
						type:'aktuelles'
					}))
				  .then(res => res.json())
				  .then(res => {
					return res;		 
				  })
}
export default NewsContainer;


// WEBPACK FOOTER //
// ./src/containers/NewsContainer.js